module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/regenerator/index.js
// module id = En79
// module chunks = 0